if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');

      // this.shipAvail = document.querySelector('.product-info #shippingTimeframe .shipping-availability');
      this.is_pdp_age = this.form.closest('.product-info');
      if (this.is_pdp_age) {
        this.shipAvail = this.is_pdp_age.querySelector('#shippingTimeframe .shipping-availability');
      }
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          if (this.shipAvail) {
            this.form.addEventListener('submit', this.checkShipping.bind(this));
          } else {
            this.form.addEventListener('submit', this.handleSubmit.bind(this));
          }
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */

    // shipping availability
    checkShipping(evt) {
      evt.preventDefault();

      if (this.is_pdp_age) {
        this.shipAvail = this.is_pdp_age.querySelector('#shippingTimeframe .shipping-availability');
      }

      let shipAvailText = this.shipAvail ? this.shipAvail.textContent.trim() : '';

      // Log for debugging to check the shipAvailText value
      console.log('Shipping Availability Text:', shipAvailText);

      // Check if the item is shipping from the UK or the Netherlands
      if (shipAvailText === 'UK' || shipAvailText === 'Netherlands') {
        let div = document.createElement('div');
        div.className = 'popup';

        // Full-screen overlay to focus attention
        div.setAttribute(
          'style',
          'position:fixed;inset:0;background:rgba(0,0,0,0.45);display:flex;align-items:center;justify-content:center;z-index:9999;padding:16px;'
        );

        // Original message logic
        let message =
          shipAvailText === 'UK'
            ? 'This product will be transferred from the UK to our NZ warehouse for dispatch.'
            : 'This product will be transferred from the Netherlands to our NZ warehouse for dispatch.';

        // Branded popup content
        div.innerHTML = `
          <div class="popup-content"
               style="
                 background-color:#ffffff;
                 color:#333333;
                 padding:32px 28px 28px;
                 max-width:560px;
                 width:100%;
                 margin:0 auto;
                 border-radius:8px;
                 border-top:6px solid #d0021b; /* red top border */
                 box-shadow:0 10px 40px rgba(0,0,0,0.25);
                 text-align:center;
                 position:relative;
               ">

            <!-- Close button -->
            <span class="popup-close-button"
                  style="
                    position:absolute;
                    top:14px;
                    right:18px;
                    font-size:26px;
                    cursor:pointer;
                    color:#333333;
                  ">&times;</span>

            <!-- Warning icon -->
<div style="margin-bottom:18px;">
  <svg viewBox="0 0 24 24" width="32" height="32" aria-hidden="true"
       style="display:block;margin:0 auto;">
    <!-- Thin outline triangle -->
    <path d="M12 3L3 20h18L12 3z"
          fill="none"
          stroke="#d0021b"
          stroke-width="1.2"
          stroke-linejoin="round" />

    <!-- Thin exclamation line -->
    <line x1="12" y1="9" x2="12" y2="15"
          stroke="#d0021b"
          stroke-width="1.2"
          stroke-linecap="round" />

    <!-- Small thin dot -->
    <circle cx="12" cy="17.5" r="1.1"
            fill="#d0021b"/>
  </svg>
</div>

            <!-- Main message -->
            <p style="
              font-size:18px;
              line-height:1.45;
              margin:0 0 28px;
              padding:0 10px;
              color:#333333;">
              ${message}
            </p>

            <!-- Buttons -->
            <div class="stock-button-wrapper"
                 style="display:flex;gap:16px;justify-content:center;flex-wrap:wrap;">

              <!-- YES button with #ebad19 -->
              <button class="confirm-yes global-button global-button--primary"
                style="
                  background:#ebad19 !important;
                  border-color:#ebad19 !important;
                  padding:14px 26px;
                  font-size:15px;
                  border-radius:4px;
                ">
                Yes, add to cart
              </button>

              <!-- NO button unchanged style-wise -->
              <button class="confirm-no global-button global-button--checkNo"
                style="
                  padding:14px 26px;
                  font-size:15px;
                  border-radius:4px;
                ">
                No, don't add to cart
              </button>
            </div>
          </div>
        `;

        document.body.appendChild(div);

        // Work within this popup instance
        const closeButton = div.querySelector('.popup-close-button');
        const confirmYes = div.querySelector('.confirm-yes');
        const confirmNo = div.querySelector('.confirm-no');

        closeButton.addEventListener('click', () => {
          div.remove();
        });

        confirmYes.addEventListener('click', () => {
          this.handleSubmit(evt);
          setTimeout(() => {
            div.remove();
          }, 1000);
        });

        confirmNo.addEventListener('click', () => {
          div.remove();
        });
      } else {
        // Log if no popup is triggered
        console.log('No popup triggered, submitting as normal.');
        this.handleSubmit(evt);
      }
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}